import { render, staticRenderFns } from "./DictData.vue?vue&type=template&id=b5fff8d2&scoped=true"
import script from "./DictData.vue?vue&type=script&lang=js"
export * from "./DictData.vue?vue&type=script&lang=js"
import style0 from "./DictData.vue?vue&type=style&index=0&id=b5fff8d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fff8d2",
  null
  
)

export default component.exports